module.exports = __webpack_public_path__ + "img/bg2.18d15368.png";